export interface Language {
	code: string;
	label: string;
	shortLabel: string;
}

const languages: Language[] = [
	{ code: 'zh-TW', label: '繁體中文', shortLabel: '中' },
	{ code: 'zh', label: '简体中文', shortLabel: '简' },
	{ code: 'en', label: 'English', shortLabel: 'EN' },
	{ code: 'ja', label: '日本語', shortLabel: '日' },
	{ code: 'vi', label: 'Tiếng Việt', shortLabel: 'VI' },
];

export default languages;
